import React, { useState, useEffect, useCallback } from 'react';

// styled-components
import styled from 'styled-components';

// react-query && axios $ URL
import { main_server_image_ip } from '../../communication_system/communication_ips';

/** 모임 결과 Entry */
function SearchModalGatheringEntry({ item, index, funcParam, setToggle }) {
    const [clickToggle, setClickToggle] = useState(false);

    useEffect(() => {
        setClickToggle(item.id === funcParam.gatheringID);
    }, [funcParam.gatheringID, item.id]);

    /** 이미지 에러처리 */
    const handleImgError = (e) => {
        e.target.src = '/images/noneImage.png';
    };

    /** 결과 선택 */
    const onClickResultID = useCallback(
        (item) => () => {
            funcParam.setGatheringID(item.id);
            funcParam.setGatheringName(item.gathering_name);
            setToggle(false);
        },
        [funcParam, setToggle],
    );

    return (
        <ColumnWrapper key={index} onClick={onClickResultID(item)} clickToggle={clickToggle}>
            <div>
                <Images
                    sizes={100}
                    src={main_server_image_ip + item.gathering_image}
                    alt="모임 이미지"
                    onError={handleImgError}
                />
            </div>
            <div>
                <ColWrapper className="pay-contents">
                    <Subtitle>모임ID</Subtitle>
                    <SubInfo>
                        <span>{item.id}</span>
                    </SubInfo>
                </ColWrapper>

                <ColWrapper className="pay-contents">
                    <Subtitle>모임명</Subtitle>
                    <SubInfo>
                        <span>{item.gathering_name}</span>
                    </SubInfo>
                </ColWrapper>

                <ColWrapper className="pay-contents">
                    <Subtitle>
                        <span>모임장</span>
                        <span style={{ margin: '0 1px' }}>/</span>
                        <span>닉네임</span>
                    </Subtitle>
                    <SubInfo>
                        {item.user_name}
                        <span style={{ margin: '0 2px' }}>/</span>
                        {item.user_nickname}
                    </SubInfo>
                </ColWrapper>

                <ColWrapper className="pay-contents">
                    <Subtitle>모임장 번호</Subtitle>
                    <SubInfo>
                        <span>{item.manager_phone_no}</span>
                    </SubInfo>
                </ColWrapper>

                <ColWrapper className="pay-contents">
                    <Subtitle>모임원</Subtitle>
                    <SubInfo>
                        <span>{item.count_crew || 0}명</span>
                    </SubInfo>
                </ColWrapper>
            </div>
        </ColumnWrapper>
    );
}

export default SearchModalGatheringEntry;

const Images = styled.img`
    object-fit: cover;

    width: ${(props) => `${props.sizes}px`};
    height: ${(props) => `${props.sizes}px`};
`;

const ColumnWrapper = styled.div`
    cursor: pointer;
    display: flex;
    align-items: start;
    justify-content: start;
    gap: 10px;

    padding-top: 5px;
    width: 100%;

    background-color: ${(props) => (props.clickToggle ? '#00000038' : '')};

    &:hover {
        background-color: #00000038;
    }
`;

const ColWrapper = styled.div`
    display: flex;
    align-items: center;

    padding: 0 1% 2% 1%;
    width: 100%;
`;

const Subtitle = styled.div`
    font-size: 13px;
    font-weight: bold;
    color: #fff;

    width: 135px;
`;

const SubInfo = styled.div`
    font-size: 13.5px;
    font-weight: 500;

    width: 100%;
    color: #fff;
`;
